import React from "react";
import { useTranslation } from "react-i18next";

export default function UpgradePopup({ open, onClose, plans = [] }) {
  const { t } = useTranslation();
  if (!open) return null;

  const getPlanBg = (planName) => {
    const name = planName.toLowerCase();
    if (name.includes("free")) return "bg-white";
    if (name.includes("silver")) return "silver-plan";
    if (name.includes("gold")) return "gold-plan";
    return "bg-white";
  };

  const styles = `
    .silver-plan {
      background: linear-gradient(135deg, #e8e8e8 0%, #f5f5f5 100%) !important;
    }
    .gold-plan {
      background: linear-gradient(135deg, #ffeaa7 0%, #fff9e6 100%) !important;
    }
    .plan-card {
      transition: all 0.3s ease;
      border: 2px solid #f1f3f5 !important;
    }
    .plan-card:hover {
      transform: translateY(-8px);
      box-shadow: 0 12px 24px rgba(0,0,0,0.15) !important;
      border-color: #dee2e6 !important;
    }
    .btn-choose {
      transition: all 0.2s ease;
    }
    .btn-choose:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 12px rgba(0,0,0,0.2);
    }
    .btn-later {
      transition: all 0.2s ease;
    }
    .btn-later:hover {
      background-color: #dc3545;
      color: white;
      border-color: #dc3545;
      transform: scale(1.02);
    }
  `;

  const overlay = {
    position: "fixed",
    inset: 0,
    background: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(4px)",
    zIndex: 1050,
  };

  return (
    <div
      style={overlay}
      className="d-flex align-items-center justify-content-center p-3"
      role="dialog"
      aria-modal="true"
      aria-label="Upgrade to premium"
    >
      <style>{styles}</style>
      <div
        className="bg-white rounded-4 shadow-lg"
        style={{ maxWidth: 900, width: "100%" }}
      >
        <div className="d-flex align-items-center justify-content-between p-4 border-bottom">
          <h4 className="mb-0 fw-bold text-dark">Upgrade to Premium</h4>
          <button className="btn-close" onClick={onClose} aria-label="Close" />
        </div>

        <div className="p-4">
          <div className="row g-4">
            {plans.map((p, idx) => (
              <div key={idx} className="col-12 col-md-6 col-lg-4">
                <div
                  className={`card border-0 shadow plan-card h-100 ${getPlanBg(
                    p.name
                  )}`}
                >
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title fw-bold text-dark mb-2">
                      {t(p.name)}
                    </h5>
                    <p className="h5 fw-bold text-primary mb-3">{p.price}</p>
                    <p className="card-text text-muted small flex-grow-1">
                      {t(p.description)}
                    </p>
                    <div className="d-grid gap-2 mt-3">
                      <button
                        className="btn bg-secondary text-white fw-semibold btn-choose"
                        onClick={onClose}
                      >
                        {t("choosePlan")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
